// map
export const SET_MAPS = "SET_MAPS";
export const SET_MAIN_MAP_MOVE_END = "SET_MAIN_MAP_MOVE_END";
export const SET_REMOVE_MAP = "SET_REMOVE_MAP";
export const SET_MAP_REFRESH_DATA = "SET_MAP_REFRESH_DATA";
export const SET_MAP_PING = "SET_MAP_PING";
export const SET_RESET_MAP_ICONS = "SET_RESET_MAP_ICONS";
export const SET_MEASURE_DISTANCE = "SET_MEASURE_DISTANCE";
export const SET_DRAW_MODE = "SET_DRAW_MODE";
export const SET_MAIN_MAP_HIJACKER = "SET_MAIN_MAP_HIJACKER";

// places
export const SET_PLACES = "SET_PLACES";
export const SET_PLACES_DETAILS = "SET_PLACES_DETAILS";
export const SET_PLACES_REFRESH_MAP = "SET_PLACES_REFRESH_MAP";

// grids
export const SET_STABILITY_PARAMS = "SET_STABILITY_PARAMS";
export const SET_STABILITY_REFRESH_MAP = "SET_STABILITY_REFRESH_MAP";

// hotspots
export const SET_HOTSPOTS = "SET_HOTSPOTS";
export const SET_HOTSPOTS_PARAMS = "SET_HOTSPOTS_PARAMS";
export const SET_HOTSPOTS_REFRESH_MAP = "SET_HOTSPOTS_REFRESH_MAP";
export const SET_HOTSPOTS_DETAILS = "SET_HOTSPOTS_DETAILS";
export const SET_HOTSPOTS_DETAILS_SELECTED_TAB =
  "SET_HOTSPOTS_DETAILS_SELECTED_TAB";
export const SET_HOTSPOTS_DETAILS_KEYWORDS = "SET_HOTSPOTS_DETAILS_KEYWORDS";
export const SET_HOTSPOTS_DETAILS_PARAMS = "SET_HOTSPOTS_DETAILS_PARAMS";

// news
export const SET_NEWS_REFRESH_MAP = "SET_NEWS_REFRESH_MAP";
export const SET_INFO_VIEWER_REFRESH = "SET_INFO_VIEWER_REFRESH";

// social
export const SET_SOCIAL_REFRESH_MAP = "SET_SOCIAL_REFRESH_MAP";

// home
export const SET_LOADING = "SET_LOADING";
export const SET_LOCKED_FEATURES = "SET_LOCKED_FEATURES";
export const SET_AUTO_REFRESH_ENABLED = "SET_AUTO_REFRESH_ENABLED";
export const SET_NOTIFIER = "SET_NOTIFIER";
export const SET_SELECTOR_PANEL = "SET_SELECTOR_PANEL";
export const SET_SELECTED_DATES = "SET_SELECTED_DATES";
export const SET_DETAILS_SIDEBAR = "SET_DETAILS_SIDEBAR";
export const SET_INFO_VIEWER_ITEMS = "SET_INFO_VIEWER_ITEMS";

// user
export const SET_PREFERENCES = "SET_PREFERENCES";
export const SET_PROFILE = "SET_PROFILE";
export const SET_GROUP_MEMBERS = "SET_GROUP_MEMBERS";
export const SET_WAITING_ON_WELCOME_MESSAGE = "SET_WAITING_ON_WELCOME_MESSAGE";

// events
export const SET_TOPICS = "SET_TOPICS";
export const SET_TOPICS_PARAMS = "SET_TOPICS_PARAMS";
export const SET_TOPICS_REFRESH_MAP = "SET_TOPICS_REFRESH_MAP";
export const SET_TOPICS_TOTAL = "SET_TOPICS_TOTAL";
export const SET_TOPICS_V2_REFRESH_MAP = "SET_TOPICS_V2_REFRESH_MAP";
export const SET_TOPICS_V2_MAP_TOPIC = "SET_TOPICS_V2_MAP_TOPIC";

// alerts
export const SET_MAPPED_ALERTS = "SET_MAPPED_ALERTS";
export const SET_USER_ALERTS = "SET_USER_ALERTS";
export const SET_USER_ALERTED_CONTENT = "SET_USER_ALERTED_CONTENT";
export const SET_USER_MAPPED_CONTENT = "SET_USER_MAPPED_CONTENT";
export const SET_ALERT_LOADING = "SET_ALERT_LOADING";
export const SET_DISPLAY_WIZARD = "SET_DISPLAY_WIZARD";
export const SET_WIZARD_DETAILS = "SET_WIZARD_DETAILS";
export const SAVING_USER_ALERT = "SAVING_USER_ALERT";
export const DELETING_USER_ALERT = "DELETING_USER_ALERT";
export const UNSUBSCRIBING_USER_ALERT = "UNSUBSCRIBING_USER_ALERT";
export const SET_ALERTS_REFRESH_MAP = "SET_ALERTS_REFRESH_MAP";
export const SET_USER_ALERTED_TRIGGERS = "SET_USER_ALERTED_TRIGGERS";
export const SET_CONTENT_PROMISE = "SET_CONTENT_PROMISE";
export const SET_TRIGGERED_ALERTS = "SET_TRIGGERED_ALERTS";
export const SET_USER_ALERTED_CONTENT_ACTION =
  "SET_USER_ALERTED_CONTENT_ACTION";

// targets
export const SET_TARGETS = "SET_TARGETS";
export const SET_TARGET = "SET_TARGET";
export const TARGETS_LOADING = "TARGETS_LOADING";
export const TARGET_LOADING = "TARGET_LOADING";
export const SAVING_TARGET = "SAVING_TARGET";
export const DELETING_TARGET = "DELETING_TARGET";

// search location
export const SET_SEARCH_KEYWORD = "SET_SEARCH_KEYWORD";
export const SET_SEARCH_LOCATION = "SET_SEARCH_LOCATION";
export const SET_SEARCH_LOCATION_REFRESH_MAP =
  "SET_SEARCH_LOCATION_REFRESH_MAP";
export const SET_SEARCH_ENABLED_ITEMS = "SET_SEARCH_ENABLED_ITEMS";
export const SET_SEARCH_DETAILS = "SET_SEARCH_DETAILS";
export const SET_SEARCH_TYPE = "SET_SEARCH_TYPE";
export const SET_SEARCH_BOUNDS = "SET_SEARCH_BOUNDS";
export const SET_SEARCH_LOADING = "SET_SEARCH_LOADING";
export const SET_TRANSLATED = "SET_TRANSLATED";

// monitor
export const SET_MONITOR_STABILITY = "SET_MONITOR_STABILITY";
export const SET_MONITOR_ENABLED = "SET_MONITOR_ENABLED";

// collaboration
export const SET_COLLABORATION_FOLDERS = "SET_COLLABORATION_FOLDERS";
export const SET_COLLABORATION_FOLDERS_CHANGED =
  "SET_COLLABORATION_FOLDERS_CHANGED";

export const SET_DAY_NIGHT_OVERLAY_REFRESH_MAP =
  "SET_DAY_NIGHT_OVERLAY_REFRESH_MAP";

export const SET_FIREBASE_ENABLED = "SET_FIREBASE_ENABLED";

export const SET_ALERT_PUSH_TIMESTAMP = "SET_ALERT_PUSH_TIMESTAMP";

// saved search
export const SET_SAVED_SEARCH_QUERIES = "SET_SAVED_SEARCH_QUERIES";
export const SET_SAVED_SEARCH_DETAILS = "SET_SAVED_SEARCH_DETAILS";
export const SET_SAVED_SEARCH_BUTTON_ACTION = "SET_SAVED_SEARCH_BUTTON_ACTION";
export const SET_SAVED_SEARCH_RENAMING = "SET_SAVED_SEARCH_RENAMING";

// communication
export const SET_SHOW_MEMBERS_ON_MAP = "SET_SHOW_MEMBERS_ON_MAP";

// power outage
export const SET_COUNTY_DETAILS = "SET_COUNTY_DETAILS";
export const SET_POWER_OUTAGE_REFRESH_MAP = "SET_POWER_OUTAGE_REFRESH_MAP";

// analysis
export const SET_ANALYSIS_DETAILS = "SET_ANALYSIS_DETAILS";

// notifications
export const SET_MODAL = "SET_MODAL";
export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";

// Charts
export const SET_CHARTS_DATA = "SET_CHARTS_DATA";

// Time
export const SET_TODAY = "SET_TODAY";

// Assets
export const SET_ASSETS_REFRESH_MAP = "SET_ASSETS_REFRESH_MAP";
export const SET_ASSETS = "SET_ASSETS";
export const SET_ASSET_TYPES = "SET_ASSET_TYPES";
export const SET_ASSET_CUSTOM_FIELDS = "SET_ASSET_CUSTOM_FIELDS";
export const SET_ASSETS_SELECTED = "SET_ASSETS_SELECTED";
export const SET_ASSETS_TABLE_OPTIONS = "SET_ASSETS_TABLE_OPTIONS";

// My Incidents
export const SET_MY_INCIDENTS = "SET_MY_INCIDENTS";
export const SAVE_MY_INCIDENT = "SAVE_MY_INCIDENT";
export const SET_MY_INCIDENTS_REFRESH_MAP = "SET_MY_INCIDENTS_REFRESH_MAP";
export const SET_MY_INCIDENTS_FILTERS = "SET_MY_INCIDENTS_FILTERS";
export const DELETE_MY_INCIDENT = "DELETE_MY_INCIDENT";
export const SET_MY_INCIDENTS_PROFILE = "SET_MY_INCIDENTS_PROFILE";
export const SET_MY_INCIDENTS_PROFILE_ERROR = "SET_MY_INCIDENTS_PROFILE_ERROR";

// Breaking Events
export const SET_BREAKING_EVENTS_DETAILS = "SET_BREAKING_EVENTS_DETAILS";

// Map Controls
export const SET_MAP_CONTROLS_REFRESH_MAP = "SET_MAP_CONTROLS_REFRESH_MAP";
export const SET_MAP_CONTROLS_PARAMS = "SET_MAP_CONTROLS_PARAMS";
export const SET_MAP_CONTROLS_EXTERNAL_REFRESH_MAP =
  "SET_MAP_CONTROLS_EXTERNAL_REFRESH_MAP";
export const SET_MAP_CONTROLS_EXTERNAL_SOURCE_ID =
  "SET_MAP_CONTROLS_EXTERNAL_SOURCE_ID";

// Risk Ratings
export const SET_RISK_RATINGS_REFRESH_MAP = "SET_RISK_RATINGS_REFRESH_MAP";

// Pulse
export const SET_PULSE_REFRESH_MAP = "SET_PULSE_REFRESH_MAP";
export const SET_PULSE_PARAMS = "SET_PULSE_PARAMS";

// Eos
export const SET_EOS_HISTORY = "SET_EOS_HISTORY";
export const UNSHIFT_EOS_HISTORY = "UNSHIFT_EOS_HISTORY";
